import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PaymentComponent } from './payment/payment.component';
import { CartComponent } from './cart/cart.component';
import { CompletedComponent } from './completed/completed.component';
import { AccountProfileComponent } from './account/profile/account.profile.component';
import { AccountCardsComponent } from './account/cards/account.cards.component';
import { AccountOrdersComponent } from './account/orders/account.orders.component';
import { AccountOrdersDetailsComponent } from './account/orders/details/account.orders.details.component';
import { AccountPointsComponent } from './account/points/account.points.component';
import { ConfigurationsResolver } from './shared/resolvers/configurations.resolver';
import { AccountSubscriptionsDetailsComponent } from './account/subscriptions/details/account.subscriptions.details.component';
import { AccountSubscriptionsListComponent } from './account/subscriptions/list/account.subscriptions.list.component';
import { CartRestorerResolver } from './shared/resolvers/cart-restorer.resolver';
import { AppsResolver } from './shared/resolvers/apps.resolver';

const routes: Routes = [
    {
        path: '',
        redirectTo: '/checkout/cart',
        pathMatch: 'full'
    },
    {
        path: 'checkout',
        redirectTo: '/checkout/cart',
        pathMatch: 'full'
    },
    { path: 'checkout/cart', component: CartComponent, resolve: {
        storeConfigurations: ConfigurationsResolver,
        cartRestore: CartRestorerResolver
    } },
    { path: 'checkout/payment', component: PaymentComponent, resolve: {
        storeConfigurations: ConfigurationsResolver,
        cartRestore: CartRestorerResolver
    } },
    { path: 'checkout/completed', component: CompletedComponent, resolve: {
        storeConfigurations: ConfigurationsResolver
    } },
    { path: 'account', redirectTo: '/account/profile', pathMatch: 'full' },
    { path: 'account/profile', component: AccountProfileComponent, resolve: {
        storeConfigurations: ConfigurationsResolver,
        apps: AppsResolver
    } },
    { path: 'account/cards', component: AccountCardsComponent, resolve: {
        storeConfigurations: ConfigurationsResolver,
        apps: AppsResolver
    } },
    { path: 'account/orders', component: AccountOrdersComponent, resolve: {
        storeConfigurations: ConfigurationsResolver,
        apps: AppsResolver
    } },
    { path: 'account/orders/:id', component: AccountOrdersDetailsComponent, resolve: {
        storeConfigurations: ConfigurationsResolver,
        apps: AppsResolver
    } },
    { path: 'account/points', component: AccountPointsComponent, resolve: {
        storeConfigurations: ConfigurationsResolver,
        apps: AppsResolver
    } },
    { path: 'account/subscriptions', component: AccountSubscriptionsListComponent, resolve: {
        storeConfigurations: ConfigurationsResolver,
        apps: AppsResolver
    } },
    { path: 'account/subscriptions/:id', component: AccountSubscriptionsDetailsComponent, resolve: {
        storeConfigurations: ConfigurationsResolver,
        apps: AppsResolver
    } },
];

@NgModule({
    imports: [ RouterModule.forRoot(routes) ],
    exports: [ RouterModule ],
    providers: [ ConfigurationsResolver, CartRestorerResolver, AppsResolver ]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// /codebuild/output/src3894461559/src/src/app/app-routing.module.ts